import * as React from "react";
import type { SVGProps } from "react";
const SvgSkiBoot = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 20c0 1.1.9 2 2 2h16.01c1.1 0 2-.9 2-2v-2.27c0-2.32-1.58-4.32-3.84-4.86-.09-.03-.18-.03-.27-.03h-.002c-.105.001-3.143.04-5.888-2.3A2.87 2.87 0 0 1 11 8.34V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1zM9 6H7c-.55 0-1 .45-1 1s.45 1 1 1h2v.34q0 .468.084.919l-2.404.801a1 1 0 0 0-.63 1.26c.14.419.528.678.946.68H6.99 7h-.004c.108 0 .206-.01.314-.05l2.532-.844q.267.395.614.733L9.1 14.55A1.01 1.01 0 0 0 10 16l-.01-.01c.37 0 .72-.2.9-.55l1.184-2.369c.616.387 1.223.69 1.802.927L13.1 15.55A1.01 1.01 0 0 0 14 17l-.01-.01c.37 0 .72-.2.9-.55l.92-1.84a9.7 9.7 0 0 0 2 .24c1.29.36 2.19 1.53 2.19 2.89V20H9c0-2.76-2.24-5-5-5V4h5zM4 17c1.65 0 3 1.35 3 3H4z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSkiBoot;
